<template>
    <Forms ref="frmSearch"
            title="Busca por Template"
            :showHelp="true"
            :showClearButton="true"
            :showSearchButton="true"
            :showNewButton="false"
            :ShowFooterImbo="true"
            :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
            v-on:Clear="onClearSection"
            v-on:Search="Search"
            >
            <div class="form-inputs">
                <label class="labelsearch">Descrição</label>
                <b-form-textarea v-model="form.descricao"  placeholder="Informe a descrição" :rows="6"/>
            </div>
            <div class="labelsearch mt-3" for="txtInsured">Data de criação</div>

            <div class="labelsearch mt-3" for="txtInsured">Desde</div>
            <div class="margem-buton d-flex align-items-end">
                <b-form-datepicker
                v-model="form.dataInclusaoInicio"
                ref="dataInicio"
                placeholder="__/__/__"
                locale="pt-BR"
                today-button
                label-today-button="Hoje"
                reset-button
                label-reset-button="Limpar"
                close-button
                label-close-button="Fechar"
                :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
            </div>
            <label class="labelsearch mt-3" for="txtInsured">Até</label>
            <div class="d-flex align-items-end">
                <b-form-datepicker
                v-model="form.dataInclusaoFim"
                ref="dataFim"
                placeholder="__/__/__"
                locale="pt-BR"
                today-button
                label-today-button="Hoje"
                reset-button
                label-reset-button="Limpar"
                close-button
                label-close-button="Fechar"
                :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
            </div>
    </Forms>
 </template>

<script>
import filterRegister from './filterRegister'
export default filterRegister
</script>

 <style scoped>
 .labelsearch{
   font-weight: 700;
   color: #666;
   font-size: 14px;
   margin-bottom: 5px;
   padding-bottom: 0;
   font-family: Segoe UI;
 }
 .margem-buton{
   margin-bottom: 0.5rem;
 }

 .margem{
   margin-top: 0.5rem;
 }
 .form-inputs{
    width: 100%;
    padding: 0.5rem 0;
}

.multiselect__option {
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  color: #333;
}

.multiselect__option--highlight {
  font-size: 14px;
  background-color: #f0f0f0;
  color: #000;
}
 </style>



// WEBPACK FOOTER //
// src/views/private/qma/registerbasicQMA/components/filterRegister/filterRegister.vue